import { isValid } from 'date-fns'

/**
 * Checks whether the provided date is an instance of Date and in the correct format
 * @param {unknown} date - date as Date instance or any other value
 * @returns {boolean}
 */
export const isValidDate = (date: unknown): date is Date => date instanceof Date && isValid(date)
